function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66699C5.40841 1.66699 1.66675 5.40866 1.66675 10.0003C1.66675 14.592 5.40841 18.3337 10.0001 18.3337C14.5917 18.3337 18.3334 14.592 18.3334 10.0003C18.3334 5.40866 14.5917 1.66699 10.0001 1.66699ZM9.37508 6.66699C9.37508 6.32533 9.65841 6.04199 10.0001 6.04199C10.3417 6.04199 10.6251 6.32533 10.6251 6.66699V10.8337C10.6251 11.1753 10.3417 11.4587 10.0001 11.4587C9.65841 11.4587 9.37508 11.1753 9.37508 10.8337V6.66699ZM10.7667 13.6503C10.7251 13.7587 10.6667 13.842 10.5917 13.9253C10.5084 14.0003 10.4167 14.0587 10.3167 14.1003C10.2167 14.142 10.1084 14.167 10.0001 14.167C9.89175 14.167 9.78341 14.142 9.68341 14.1003C9.58341 14.0587 9.49175 14.0003 9.40841 13.9253C9.33341 13.842 9.27508 13.7587 9.23341 13.6503C9.19175 13.5503 9.16675 13.442 9.16675 13.3337C9.16675 13.2253 9.19175 13.117 9.23341 13.017C9.27508 12.917 9.33341 12.8253 9.40841 12.742C9.49175 12.667 9.58341 12.6087 9.68341 12.567C9.88341 12.4837 10.1167 12.4837 10.3167 12.567C10.4167 12.6087 10.5084 12.667 10.5917 12.742C10.6667 12.8253 10.7251 12.917 10.7667 13.017C10.8084 13.117 10.8334 13.2253 10.8334 13.3337C10.8334 13.442 10.8084 13.5503 10.7667 13.6503Z",
    fill: "#292D32",
    style: {
      fill: "#292D32",
      fill: "color(display-p3 0.1608 0.1765 0.1961)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5a3e632b6450b14be284f93eb6d47084.svg";
export { ForwardRef as ReactComponent };